// Swiper
import Swiper from 'swiper';
import { EffectFade, Navigation as SwiperNavigation } from 'swiper/modules';
Swiper.use([EffectFade, SwiperNavigation]);

// Core
import { BREAKPOINTS } from '~scripts/core/breakpoints';

// Breakpoints
const mediaSm = window.matchMedia(`(max-width: ${BREAKPOINTS.smMax})`);

// Slider
const slidesCount = document.getElementById('customer-feedbacks-slider').querySelectorAll('.swiper-slide').length;

export default function customerFeedbacksInit() {
  const customerFeedbacksSliderOptionsSm = {
    allowTouchMove: true,
    effect: 'slide',
    loop: false,
    navigation: false,
    noSwiping: false,
    slidesPerView: 'auto',
    spaceBetween: 30,
    breakpoints: {
      361: {
        spaceBetween: 40,
      },
    },
  };
  const customerFeedbacksSliderOptionsMd = {
    allowTouchMove: false,
    effect: 'fade',
    loop: slidesCount > 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    noSwiping: true,
    slidesPerView: 1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    spaceBetween: 0,
    watchOverflow: true,
  };

  let customerFeedbacksSlider = null;

  const handleCustomerFeedbacksSliderInit = () => {
    if (customerFeedbacksSlider) {
      customerFeedbacksSlider.destroy();
    }

    const options = mediaSm.matches ? customerFeedbacksSliderOptionsSm : customerFeedbacksSliderOptionsMd;

    customerFeedbacksSlider = new Swiper('#customer-feedbacks-slider', options);
  };

  handleCustomerFeedbacksSliderInit();
  mediaSm.addEventListener('change', handleCustomerFeedbacksSliderInit);
}
